const initialState = () => ({
  notifications: [],
  pagination: {
    current_page: 0
  },
  total_unread: 0
})

export default initialState
